import { Button, styled, IconButton } from "@mui/material";
import colors from "../../styles/colors";

// Original white button
const StyledButton = styled(Button)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 400,
  letterSpacing: "0.2rem",
  backgroundColor: "transparent",
  color: "white",
  padding: "4px 16px",
  transition: "all 0.2s ease-in-out",
  borderRadius: "0px 0px 0px 0px",
  border: "1px solid white",
  zIndex: 30,
  pointerEvents: "auto",
  minWidth: "auto", // Changed from default to auto
  width: "auto", // Added to ensure it wraps content
  transformOrigin: "center center",

  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.14)",
  },
}));

// New black variant
const StyledButtonBlack = styled(Button)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 400,
  letterSpacing: "0.2rem",
  backgroundColor: "transparent",
  color: "black",
  padding: "4px 16px",
  transition: "all 0.2s ease-in-out",
  borderRadius: "0px 0px 0px 0px",
  border: "1px solid black",
  zIndex: 30,
  pointerEvents: "auto",
  minWidth: "auto", // Changed from default to auto
  width: "auto", // Added to ensure it wraps content
  transformOrigin: "center center",

  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
  },
}));

// New round play/pause button for music player
const PlaybackButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: colors.darkGray,
  color: "white",
  padding: "12px",
  transition: "all 0.2s ease-in-out",
  borderRadius: "50%", // Make it round
  zIndex: 30,
  pointerEvents: "auto",

  "&:hover": {
    backgroundColor: colors.antracite,
  },
}));

export { StyledButtonBlack, PlaybackButton };
export default StyledButton;
